var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.465,6.979c.776,0,1.594.298,2.168.563.467.216.765.68.765,1.194v7.747c0,1.564-1.398,2.703-2.949,2.494-.519-.07-1.05-.106-1.59-.106-1.637,0-3.183.335-4.576.918h-.283"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12,19.75V5.632c1.346-.896,2.961-1.42,4.699-1.42.169,0,.336.005.502.015.705.042,1.264.608,1.264,1.314v8.99c0,.616-.431,1.141-1.031,1.275-2.307.516-4.256,1.972-5.434,3.944Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5.535,6.979c-.776,0-1.594.298-2.168.563-.467.216-.765.68-.765,1.194v7.747c0,1.564,1.398,2.703,2.949,2.494.519-.07,1.05-.106,1.59-.106,1.637,0,3.183.335,4.576.918h.283"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m5.535,5.542c0-.706.559-1.272,1.264-1.314.166-.01.333-.015.502-.015,1.738,0,3.353.524,4.699,1.42v14.118c-1.178-1.972-3.127-3.428-5.434-3.944-.601-.134-1.031-.659-1.031-1.275V5.542Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.39285a7c3f2ac3f4112895c0373d981d.svg";
export { ForwardRef as ReactComponent };